"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetEnrichedCategories = void 0;
const react_1 = require("react");
const R = __importStar(require("ramda"));
const get_product_tree_nodes_hook_1 = __importDefault(require("./get-product-tree-nodes.hook"));
const store_1 = require("../../../../store");
const useGetEnrichedCategories = (categories) => {
    const allCategoryIds = (0, react_1.useMemo)(() => (categories
        ? R.pipe(R.chain((cat) => [
            cat.id,
            ...(cat.children ? cat.children : []),
        ]), R.uniq, R.filter((id) => typeof id === 'string'))(categories)
        : []), [categories]);
    const filter = (0, react_1.useMemo)(() => ({
        id: { in: allCategoryIds },
    }), [allCategoryIds]);
    const productTreeId = (0, store_1.useProductTreeId)();
    const { data: productTreeNodes, isLoading } = (0, get_product_tree_nodes_hook_1.default)({
        productTreeId,
        filter,
        options: {
            skip: allCategoryIds.length === 0,
        },
    });
    const enrichedCategories = (0, react_1.useMemo)(() => {
        if (!categories || !productTreeNodes || isLoading) {
            return [];
        }
        const idToLabelMap = productTreeNodes.reduce((acc, node) => {
            acc[node.id] = node.title;
            return acc;
        }, {});
        const enrichCategory = (cat) => ({
            label: idToLabelMap[cat.id] || cat.id,
            value: cat.id,
            children: cat.children
                ? cat.children.map((childId) => ({
                    label: idToLabelMap[childId] || childId,
                    value: childId,
                }))
                : undefined,
            allSelected: !cat.children || cat.children.length === 0,
        });
        return categories.map(enrichCategory);
    }, [categories, isLoading, productTreeNodes]);
    return {
        data: enrichedCategories,
        isLoading,
    };
};
exports.useGetEnrichedCategories = useGetEnrichedCategories;
